<template>
    <sidebar @close="$emit('close')">
        <template v-slot:title>
            {{ plan.name }}
        </template>

        <template v-slot:header>
            <div class="row mb-1">
                <div class="col">
                    <span class="text-muted">{{ plan.state_pretty || 'All States' }}&nbsp;&middot; Accrual Plan&nbsp;&middot; Used by {{ plan.client_count }} {{ plan.client_count == 1 ? 'client' : 'clients' }}</span>
                </div>
            </div>

            <div class="mb-1">
                <button class="btn btn-outline-primary" type="button" @click.prevent="editIsOpen = true">
                    <i class="far fa-pen" aria-hidden="true" title="Edit"></i>
                    Edit
                </button>
                <button class="btn btn-outline-primary ml-1" type="button" @click.prevent="onDelete" v-if="!plan.client_count">Deactivate</button>
            </div>

            <div class="nav-tabs-container">
                <div class="nav-tabs-scroll-helper">
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link" :class="{active: activeTab == 'main'}" href @click.prevent="activeTab = 'main'" role="tab" :aria-selected="activeTab == 'main'">Main</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{active: activeTab == 'history'}" href @click.prevent="activeTab = 'history'" role="tab" :aria-selected="activeTab == 'history'">Change History</a>
                        </li>
                    </ul>
                </div>
            </div>
        </template>

        <slot>
            <plan-overview v-if="activeTab == 'main'" :plan="plan" />

            <!-- Keyed on the plan so an edit reloads it. -->
            <plan-change-history v-if="activeTab == 'history'" :key="plan.updated_on" :url="`/admin/accruals/plans/${plan.id}/history`" />

            <plan-modal v-if="editIsOpen" :plan="plan" @updated="onUpdate" @close="editIsOpen = false"/>
        </slot>
    </sidebar>
</template>

<script>
import Sidebar from '@/components/Sidebar'
import PlanModal from './PlanModal'
import PlanOverview from './PlanOverview'
import PlanChangeHistory from './PlanChangeHistory'

export default {
    components: {Sidebar, PlanModal, PlanOverview, PlanChangeHistory, },
    props: ['plan', ],
    data() {
        return {
            editIsOpen: false,
            activeTab: 'main',
        }
    },
    methods: {
        onDelete() {
            if (!confirm("Are you sure?")) {return}

            this.$store.dispatch('START_LOADING')
            this.$api.del(`/admin/accruals/plans/${this.plan.id}`).then(() => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('deleted')
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
        onUpdate($event) {
            this.$emit('updated', $event)
        },
    },
}
</script>
